import * as React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

function docs({color = "#000", ...props}: IconProps) {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_25026_40392)">
                <path d="M7.29167 6.2487V3.1237C7.29167 2.84743 7.40141 2.58248 7.59676 2.38713C7.79211 2.19178 8.05707 2.08203 8.33333 2.08203H20.8333C21.1096 2.08203 21.3746 2.19178 21.5699 2.38713C21.7653 2.58248 21.875 2.84743 21.875 3.1237V17.707C21.875 17.9833 21.7653 18.2483 21.5699 18.4436C21.3746 18.639 21.1096 18.7487 20.8333 18.7487H17.7083V21.8737C17.7083 22.4487 17.2396 22.9154 16.6594 22.9154H4.17396C4.03659 22.9162 3.90041 22.8899 3.77325 22.8379C3.64609 22.7859 3.53045 22.7093 3.43298 22.6126C3.3355 22.5158 3.25812 22.4007 3.20526 22.2739C3.15241 22.1471 3.12513 22.0111 3.125 21.8737L3.12813 7.29037C3.12813 6.71536 3.59688 6.2487 4.17708 6.2487H7.29167ZM9.375 6.2487H17.7083V16.6654H19.7917V4.16536H9.375V6.2487ZM7.29167 11.457V13.5404H13.5417V11.457H7.29167ZM7.29167 15.6237V17.707H13.5417V15.6237H7.29167Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_25026_40392">
                    <rect width="25" height="25" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default docs
